import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { NavService } from '../../_services/_nav.service';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component( {
  selector: 'app-estructura-fisica-listado',
  templateUrl: 'estructura-fisica-listado.component.html'
} )

export class EstructuraFisicaListadoComponent implements OnInit {

  columnas: any[] = [];
  estFisica: EstructuraFisica[] = [];
  carEstructuraFisica = true;
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  menZonas: Funcionalidad = new Funcionalidad();
  nivUsuario: number;
  menGrupos: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private estFisicaServicio: EstructuraFisicaService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/estructura-fisica' );
    if ( mn ) {
      this.menu = mn;
    }

    const menZonas = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/zonas' );
    if ( menZonas ) {
      this.menZonas = menZonas;
    }

    const menGrupo = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/grupos' );
    if ( menGrupo ) {
      this.menGrupos = menGrupo;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_CODIGO' ), sort: true },
      { field: 'estructuraFisica', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_NOMBRE' ), sort: true },
      { field: 'categoria', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_CATEGORIA' ), sort: true },
      { field: 'direccion', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_DIRECCION' ), sort: true },
      { field: 'nroZonas', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_NUMEROZONAS' ), sort: true },
      { field: 'indicadorVirtual', header: this.navServicio.buscarMensaje( 'ESTRUCTURAFISICA.LBL_VIRTUAL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'estructura-fisica.component' );

    this.estFisicaServicio.obtenerOficinasUsuarioSesion().subscribe( estFisica => {
      this.estFisica = estFisica;
      this.nivUsuario = this.autServicio.obtenerNivelMaximo();
      this.carEstructuraFisica = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

  }

  setBusqueda() {
    this.navServicio.setSearch( 'estructura-fisica.component', this.busqueda );
  }

  verEstructura( estFisica: EstructuraFisica ) {
    this.router.navigate( [ 'apl/estructura-fisica/detalle/' + estFisica.idEstructuraFisica ] );
  }

  asignarZona( estFisica: EstructuraFisica ) {
    this.router.navigate( [ 'apl/estructura-fisica/asignar-zona/' + estFisica.idEstructuraFisica ] );
  }

  asignarEjecutivo( estFisica: EstructuraFisica ) {
    this.router.navigate( [ 'apl/estructura-fisica/asignar-ejecutivo/' + estFisica.idEstructuraFisica ] );
  }

  asignarOficina( estFisica: EstructuraFisica ) {
    this.router.navigate( [ 'apl/estructura-fisica/estructura-oficina/' + estFisica.idEstructuraFisica ] );
  }

  asignarGrupo( estFisica: EstructuraFisica ) {
    this.router.navigate( [ 'apl/estructura-fisica/asignar-grupo/' + estFisica.idEstructuraFisica ] );
  }
}
